import axiosClient from './axiosClient'

const boardTypeApi = {
  create: params => axiosClient.post('boardTypes', params),
  getAll: () => axiosClient.get('boardTypes'),
  delete: (id) => axiosClient.delete(`boardTypes/${id}`),
  update: (id, params) => axiosClient.put(`boardTypes/${id}`, params),
}

export default boardTypeApi